import { apiSlice } from './apiSlice';
import {PARTNERS_URL} from "../constants";

export const partnerApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        registerPartner: builder.mutation({
            query: (data) => ({
                url: PARTNERS_URL,
                method: 'POST',
                body: data,
            }),
        }),
        getPartners: builder.query({
            query: ({ pageNumber, pageSize, keyword, status }) => ({
                url: PARTNERS_URL,
                params: {
                    pageNumber,
                    pageSize,
                    keyword,
                    status,
                },
            }),
            keepUnusedDataFor: 5,
        }),
        updatePartnerStatus: builder.mutation({
            query: ({ id, status }) => ({
                url: `${PARTNERS_URL}/${id}`,
                method: 'PUT',
                body: { status },
            }),
        }),
    }),
});

export const { useRegisterPartnerMutation, useGetPartnersQuery, useUpdatePartnerStatusMutation } = partnerApiSlice;
